<template>
  <el-select
    v-model="dataValue"
    style="width: 200px;"
    placeholder="请选择机构"
    clearable=""
    @change="onChage"
  >
    <el-option
      v-for="item in list"
      :key="item.sgsId"
      :label="item.sgsName"
      :value="item.sgsId"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'SeaportSelect',
  props: ['value', 'callback'],
  data() {
    return {
      list: [],
      config: { pageSize: 1000, pageNum: 1 }
    }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.getSeaports()
  },
  methods: {
    onChage() {
      this.callback && this.callback()
    },
    getSeaports() {
      this.loading = true
      this.$store.dispatch('account/getsgslist', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" type="text/stylus" scoped></style>
